/**
 * Custom Product Grid
 * AJAX filtering, sorting, and pagination via Shopify Section Rendering API.
 * Supports drawer and sidebar filter styles.
 */
(function () {
  var section = document.querySelector('[data-custom-pg]');
  if (!section) return;

  var sectionId = section.dataset.sectionId;
  var gridArea = section.querySelector('[data-pg-grid-area]');
  var filterDrawer = section.querySelector('[data-pg-filter-drawer]');
  var filterOverlay = section.querySelector('[data-pg-filter-overlay]');

  // Collect all filter forms (sidebar + drawer may both exist)
  function getFilterForms() {
    return section.querySelectorAll('[data-pg-filter-form]');
  }

  // ---- AJAX section fetch ----

  function fetchSection(url) {
    section.classList.add('is-loading');

    var separator = url.indexOf('?') !== -1 ? '&' : '?';
    var fetchUrl = url + separator + 'sections=' + sectionId;

    return fetch(fetchUrl)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data[sectionId];
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newSection = doc.querySelector('[data-custom-pg]');

        if (newSection) {
          // Replace grid area
          var newGridArea = newSection.querySelector('[data-pg-grid-area]');
          if (newGridArea && gridArea) {
            gridArea.innerHTML = newGridArea.innerHTML;
          }

          // Replace toolbar
          var newToolbar = newSection.querySelector('.custom-pg__toolbar-' + sectionId);
          var oldToolbar = section.querySelector('.custom-pg__toolbar-' + sectionId);
          if (newToolbar && oldToolbar) {
            oldToolbar.innerHTML = newToolbar.innerHTML;
          }

          // Replace active filter tags
          var newActiveTags = newSection.querySelector('.custom-pg__active-filters-' + sectionId);
          var oldActiveTags = section.querySelector('.custom-pg__active-filters-' + sectionId);
          if (newActiveTags && oldActiveTags) {
            oldActiveTags.outerHTML = newActiveTags.outerHTML;
          } else if (newActiveTags && !oldActiveTags) {
            var toolbar = section.querySelector('.custom-pg__toolbar-' + sectionId);
            if (toolbar) toolbar.insertAdjacentHTML('afterend', newActiveTags.outerHTML);
          } else if (!newActiveTags && oldActiveTags) {
            oldActiveTags.remove();
          }

          // Replace ALL filter form contents (sidebar + drawer)
          var newForms = newSection.querySelectorAll('[data-pg-filter-form]');
          var oldForms = getFilterForms();
          newForms.forEach(function (newForm, i) {
            if (oldForms[i]) {
              oldForms[i].innerHTML = newForm.innerHTML;
            }
          });

        }

        section.classList.remove('is-loading');
        history.pushState(null, '', url);
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
      .catch(function () {
        section.classList.remove('is-loading');
        window.location.href = url;
      });
  }

  // ---- Filter drawer open/close ----

  var lockedByDrawer = false;
  var drawerOpener = null;

  function isDrawerOpen() {
    return !!(filterDrawer && filterDrawer.classList.contains('is-open'));
  }

  function openFilterDrawer() {
    if (filterDrawer) filterDrawer.classList.add('is-open');
    if (filterOverlay) filterOverlay.classList.add('is-open');
    // Only take the scroll lock if nothing else (Impulse's own drawers) holds it
    if (!document.body.style.overflow) {
      document.body.style.overflow = 'hidden';
      lockedByDrawer = true;
    }
    drawerOpener = document.activeElement;
    var closeBtn = filterDrawer && filterDrawer.querySelector('[data-pg-filter-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeFilterDrawer() {
    if (filterDrawer) filterDrawer.classList.remove('is-open');
    if (filterOverlay) filterOverlay.classList.remove('is-open');
    if (lockedByDrawer) {
      document.body.style.overflow = '';
      lockedByDrawer = false;
    }
    if (drawerOpener && typeof drawerOpener.focus === 'function') drawerOpener.focus();
    drawerOpener = null;
  }

  // Escape closes; Tab stays inside the open drawer
  document.addEventListener('keydown', function (e) {
    if (!isDrawerOpen()) return;
    if (e.key === 'Escape') { closeFilterDrawer(); return; }
    if (e.key !== 'Tab') return;
    var focusable = filterDrawer.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // Sidebar mode: the drawer only exists below 768px. Rotating past it with
  // the drawer open used to leave it open and the page locked.
  if (section.querySelector('[data-pg-sidebar]') && window.matchMedia) {
    var sidebarQuery = window.matchMedia('(min-width: 768px)');
    var onSidebarQuery = function (e) { if (e.matches && isDrawerOpen()) closeFilterDrawer(); };
    if (sidebarQuery.addEventListener) sidebarQuery.addEventListener('change', onSidebarQuery);
    else if (sidebarQuery.addListener) sidebarQuery.addListener(onSidebarQuery);
  }

  // ---- Build filter URL from a specific form ----

  function buildFilterUrl(form) {
    if (!form) {
      var forms = getFilterForms();
      form = forms[0];
    }
    if (!form) return window.location.pathname;

    var params = [];
    var inputs = form.querySelectorAll('input');

    inputs.forEach(function (input) {
      if (input.type === 'checkbox' && input.checked) {
        params.push(encodeURIComponent(input.name) + '=' + encodeURIComponent(input.value));
      } else if (input.type === 'number' && input.value) {
        var cents = Math.round(parseFloat(input.value) * 100);
        if (!isNaN(cents) && cents > 0) {
          params.push(encodeURIComponent(input.name) + '=' + cents);
        }
      }
    });

    var sortSelect = section.querySelector('[data-pg-sort]');
    if (sortSelect && sortSelect.value) {
      params.push('sort_by=' + encodeURIComponent(sortSelect.value));
    }

    var path = window.location.pathname;
    return params.length > 0 ? path + '?' + params.join('&') : path;
  }

  // ---- Event binding (delegated, bound once) ----
  // The AJAX refresh replaces the grid, the active-tag strip and the filter
  // form contents. Handlers are delegated from the section root, so nothing
  // is re-bound after a fetch and no node ever carries a duplicate listener
  // (previously bindEvents() re-ran after every fetch and the Nth Apply fired
  // N requests, each with its own pushState and scrollIntoView).

  function bindEvents() {
    section.addEventListener('click', function (e) {
      var t = e.target;

      if (t.closest('[data-pg-filter-open]')) { openFilterDrawer(); return; }
      if (t.closest('[data-pg-filter-close]')) { closeFilterDrawer(); return; }

      if (t.closest('[data-pg-filter-apply]')) {
        var drawerForm = filterDrawer ? filterDrawer.querySelector('[data-pg-filter-form]') : null;
        closeFilterDrawer();
        fetchSection(buildFilterUrl(drawerForm));
        return;
      }

      // Filter link clicks (active tag removal, clear all)
      var link = t.closest('[data-pg-filter-link]');
      if (link) {
        e.preventDefault();
        closeFilterDrawer();
        fetchSection(link.href);
        return;
      }

      // Pagination links
      var page = t.closest('[data-pg-page-link]');
      if (page) {
        e.preventDefault();
        fetchSection(page.href);
        return;
      }

      // Mobile tap for overlay/corner_text cards
      var card = t.closest('[data-pg-card]');
      if (card) {
        if (window.innerWidth > 767) return;
        var style = card.className;
        if (style.indexOf('overlay') === -1 && style.indexOf('corner_text') === -1) return;
        if (!card.hasAttribute('data-pg-tapped')) {
          e.preventDefault();
          section.querySelectorAll('[data-pg-tapped]').forEach(function (el) {
            el.removeAttribute('data-pg-tapped');
          });
          card.setAttribute('data-pg-tapped', '');
        }
      }
    });

    section.addEventListener('change', function (e) {
      var t = e.target;

      // Sort change
      if (t.matches('[data-pg-sort]')) {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', t.value);
        fetchSection(url.pathname + url.search);
        return;
      }

      // Sidebar: auto-apply on checkbox change, price inputs on change/blur
      var sidebarForm = t.closest('[data-pg-sidebar] [data-pg-filter-form]');
      if (sidebarForm && (t.type === 'checkbox' || t.type === 'number')) {
        fetchSection(buildFilterUrl(sidebarForm));
      }
    });

    if (filterOverlay) {
      filterOverlay.addEventListener('click', closeFilterDrawer);
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-pg-card]')) {
        section.querySelectorAll('[data-pg-tapped]').forEach(function (el) {
          el.removeAttribute('data-pg-tapped');
        });
      }
    });
  }

  window.addEventListener('popstate', function () {
    fetchSection(window.location.href);
  });

  bindEvents();
})();
